import React, { useState } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setArticles, setWorks } from './redux';

import Login from './layouts/Login';
import Loader from './layouts/Loader';
import Header from './layouts/Header';
import Footer from './layouts/Footer';

import VanRah from './pages/VanRah';
import Error from './pages/Error';
import Illustrations from './pages/Illustrations';
import Works from './pages/Works';
import Work from './pages/Work';
import Planning from './pages/Planning';
import Shop from './pages/Shop';
import Article from './pages/Article';
import Orders from './pages/Orders';
import Delivery from './pages/Delivery';

import './App.css'

function App() {
    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(false);

    const worksData = useSelector(state => state.works);
    const articlesData = useSelector(state => state.articles);
    const headerHeight = useSelector(state => state.options.headerHeight);

    useEffect(() => {
        const setButtonTypes = () =>
            document.querySelectorAll('button:not([type])').forEach(btn =>
                btn.setAttribute('type', 'button')
            );

        setButtonTypes();
        
        const observer = new MutationObserver(setButtonTypes);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const fetchWorksData = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/works/get`);
            const res = await req.json();

            if (req.status !== 200) alert(res.message);
            dispatch(setWorks(res.sort((a, b) => a.order - b.order)));
        }
        fetchWorksData();

        const fetchArticlesData = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/articles/get/all`);
            const res = await req.json();

            if (req.status !== 200) alert(res.message);
            dispatch(setArticles(res.sort((a, b) => a.order - b.order)));
        }
        fetchArticlesData();
    }, [dispatch]);

    // "Ctrl + scroll" desactivation
    document.addEventListener('wheel', (e) => {
        if (e.ctrlKey) {
            e.preventDefault();
        }
    }, { passive: false });

    // "Touch + scroll" desactivation
    document.addEventListener('touchmove', (e) => {
        if (e.touches.length > 1) {
            e.preventDefault();
        }
    }, { passive: false });

    return (
        <React.StrictMode>
            <Router>
                <Login />
                <Header setShowLoader={setShowLoader} />
                
                {showLoader && <Loader setShowLoader={setShowLoader} />}

                <main style={{
                    minHeight: `calc(100vh - ${headerHeight}px)`,
                    marginTop: `${headerHeight}px`
                }}>
                    <Routes>
                        <Route path="/" element={<VanRah />} />
                        <Route path="*" element={<Error />} />

                        <Route path="/illustrations" element={<Illustrations />} />
                        <Route path="/planning" element={<Planning />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/delivery" element={<Delivery />} />

                        {/* ------------------------------------------------------------------------------ */}
                        
                        <Route path="/mangas" element={<Works type={1} />} />
                        <Route path="/manga/newwork" element={<Work work="new" type={1} />} />
                        
                        <Route path="/works" element={<Works type={2} />} />
                        <Route path="/work/newwork" element={<Work work="new" type={2} />} />

                        {worksData && worksData.length > 0 && worksData.map((work, idx) => (
                            <Route
                            key={idx}
                            path={`/${work.type === 1 ? 'manga' : 'work'}/${work.title_path}`}
                            element={<Work work={work} type={work.type} />}
                            />
                        ))}

                        {/* ------------------------------------------------------------------------------ */}
                        
                        <Route path="/shop" element={<Shop />} />
                        <Route path="/article/newarticle" element={<Article article="new" />} />

                        {articlesData && articlesData.length > 0 && articlesData.map((article, idx) => (
                            <Route
                                key={idx}
                                path={`/article/${article.title_path}`}
                                element={<Article article={article} />}
                            />
                        ))}
                    </Routes>
                </main>

                <Footer />
            </Router>
        </React.StrictMode>
    )
}

export default App;